import { Component, OnInit } from '@angular/core';
import { Router} from '@angular/router';
import { MachineService } from '../../services/machine.service';
import {Machine} from "../../models/machine";
import {AccountService} from "../../services/account.service";
import {UserService} from "../../services/user.service";

@Component({
    selector: 'machine-list',
    templateUrl: 'machine-list.component.html',
    styleUrls: ['machine-list.component.css'],
    moduleId: module.id
})
export class MachineListComponent implements OnInit{
    machines: Machine[];
    loading: boolean = true;
    noMachinesError = false;
    public router: Router;
    private modalHide = [true];
    private isSuper: boolean = false;

    constructor(
        private _router: Router,
        private machineService: MachineService,
        private accountService: AccountService,
        private userService: UserService
    ) {
        this.router = _router;
    };
    getMachines(): void {
        this.loading = true
        let accountRole = this.userService.accountRole;
        let userId = this.userService.userId;
        this.machineService.getMachinesByRole(accountRole, userId)
        .then(machines => {
            if (!machines) {
                this.noMachinesError = true;
            } else {
                this.machines = machines;
            }
            this.loading = false;
        })
    };
    ngOnInit(): void {
        this.isSuper = this.userService.isSuper;
        this.getMachines();
    };

    gotoEdit(machine: Machine): void {
      this.router.navigate(['/machines', machine.id, 'general']);
    };

    getAccountName(machine: Machine): String {
        return this.accountService.accountMap[machine.accountId].name;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/machine-list/machine-list.component.ts